import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import axios from 'axios';
import config from '../config';
import BetweenAds from '../components/BetweenAds';
import HeaderAdBanner from '../components/HeaderAdBanner';
import AgeGateModal from '../components/AgeGateModal';
import SeoHead from '../components/SeoHead';
import { carPath } from '../utils/carUrl';
import '../styles/ads.css';

const SearchCar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [showAgeGate, setShowAgeGate] = useState(false);
  const [pendingCar, setPendingCar] = useState(null);

  useEffect(() => {
    sessionStorage.removeItem('homeScrollPosition');
    try {
      localStorage.removeItem('ageConfirmed');
    } catch {
      /* ignore */
    }
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    setLoading(true);
    setSearched(true);
    try {
      const response = await axios.get(
        `${config.API_URL}/api/cars/search/${encodeURIComponent(searchTerm)}`
      );
      setResults(response.data);
    } catch (error) {
      console.error('Qidiruvda xatolik:', error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (car) => {
    setPendingCar(car);
    setShowAgeGate(true);
  };

  return (
    <div className="container page-shell">
      <SeoHead
        title={t('searchCar.title') || 'Qidiruv'}
        description={t('searchCar.description') || "Davlat raqami bo'yicha avtomobil tarixini qidiring"}
        canonical="https://avto-tarix.uz/search"
      />
      <HeaderAdBanner />
      <h1 className="page-shell__title">{t('searchCar.title')}</h1>
      <p className="page-shell__lead">{t('searchCar.description')}</p>

      <form onSubmit={handleSearch} className="search-bar">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={t('searchCar.placeholder')}
          className="form-input"
          autoCapitalize="characters"
        />
        <button type="submit" className="btn btn-primary" disabled={loading}>
          <Search size={18} />
          {loading ? t('searchCar.searching') : t('searchCar.search')}
        </button>
      </form>

      {loading ? (
        <div className="loading">
          <div className="spinner" />
          <p>{t('searchCar.searching')}</p>
        </div>
      ) : searched && results.length === 0 ? (
        <div className="empty-state">
          <h3>{t('searchCar.noResults')}</h3>
          <p>{t('searchCar.noResultsDescription')}</p>
        </div>
      ) : results.length > 0 ? (
        <div>
          <div className="section__head">
            <h2 className="section__title">
              {t('searchCar.resultsFound')}: {results.length}
            </h2>
          </div>
          <div className="archive-grid">
            <BetweenAds cars={results} onViewDetails={handleViewDetails} />
          </div>
        </div>
      ) : null}

      <AgeGateModal
        open={showAgeGate}
        onCancel={() => {
          setShowAgeGate(false);
          setPendingCar(null);
        }}
        onConfirm={() => {
          setShowAgeGate(false);
          if (pendingCar) {
            const car = pendingCar;
            setPendingCar(null);
            navigate(carPath(car));
          }
        }}
      />
    </div>
  );
};

export default SearchCar;
